// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__OUg73","breadcrumbText":"Breadcrumbs_breadcrumbText__FS6Xu"};